import { Route, Routes } from 'react-router-dom';

import { DefaultLayout } from 'layouts/DefaultLayout';

import { List } from './components/List';

export function PricesPage(): React.ReactElement {
  return (
    <DefaultLayout isNested withHeader>
      <Routes>
        <Route index element={<List />} />
      </Routes>
    </DefaultLayout>
  );
}
